import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-mobilization-shell',
    standalone: true,
    imports: [RouterModule],
    templateUrl: './mobilization-shell.component.html',
    styleUrls: ['./mobilization-shell.component.css']
})
export class MobilizationShellComponent {}
